import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    preview() {
        this.outputTarget.innerHTML = "";
        const files = this.inputTarget.files;
        if (!files)
            return;
        Array.from(files).forEach((file) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const container = document.createElement("div");
                container.classList.add("mb-2");
                const result = e.target?.result;
                if (file.type.startsWith("image/") && typeof result === "string") {
                    const img = document.createElement("img");
                    img.src = result;
                    img.style.maxWidth = "200px";
                    img.classList.add("img-thumbnail");
                    container.appendChild(img);
                }
                else {
                    const span = document.createElement("span");
                    span.textContent = file.name;
                    container.appendChild(span);
                }
                this.outputTarget.appendChild(container);
            };
            reader.readAsDataURL(file);
        });
    }
}
default_1.targets = ["input", "output"];
export default default_1;
